import {useSelector} from "react-redux";
import {userinfoSelector,dashboardSelector} from "../../slices/UserSlice";
import {Speedo} from '../index'
import Spinner from './Spinner'

const Userbanner = () => {


    const dataneeded = useSelector(userinfoSelector)
    const status = useSelector((state) => state.userinfo.items.code)


    let content

    if (status ==1) {
        content = <h3 className='clrtwotext'>{dataneeded.user.name}</h3>
    } else {
        content =
            <Spinner/>

    }


    return (
        <>
        <div className="columns is-multiline m-0 welcome__master mt-3">
                <div className="column  is-12  p-3  has-text-centered">

                    <div className='is-flex is-flex-direction-column is-justify-content-space-around '
                         style={{height: '100%', width: '100%'}}>
                        <span className="is-flex is-flex-direction-column width100 ">
                            <p>خوش اومدی</p>
                            {
                                content
                            }

                            <h4> پنل خود را مدیریت کنید  🩺</h4>
                        </span>

                        <div className='columns m-0 width100 lightborder borderrad1 '>
                            <div className='column is-3 pinar '>


                                دفعات ورود:
                                <p className='has-text-weight-bold my-2'>

                                    {
                                        status ==1 ?
                                            dataneeded.user.login_count : <Spinner/>
                                    }
                                </p>


                            </div>

                            <div className='column is-3 pinar'>
                                آخرین ورود:
                                <p className='has-text-weight-bold my-2'>

                                    {
                                        status ==1 ?
                                            new Date(dataneeded.user.last_login * 1000).toLocaleString("fa-IR") :
                                            <Spinner/>

                                    }
                                </p>

                            </div>

                            <div className='column is-3 pinar '>


                               مرکز پستی :
                                <p className='has-text-weight-bold my-2'>

                                    {
                                        status ==1 ?
                                            dataneeded.user.name : <Spinner/>
                                    }
                                </p>


                            </div>

                            <div className='column is-3 pinar '>


                                تلفن مرکز :
                                <p className='has-text-weight-bold my-2'>

                                    {
                                        status ==1 ?
                                            dataneeded.user.tel : <Spinner/>
                                    }
                                </p>


                            </div>


                        </div>

                    </div>


                </div>





        </div>

        </>
    )
}
export default Userbanner;